import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  rootFormControl: {
    width: 'auto',
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
  formHelperText: {
    margin: '8px 14px 0px 14px',
  },
});

const SignUpForm = props => {
  const classes = useStyles();
  const {
    values: { name, firstLastName, secondLastName, gender },
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    // setTouched,
    // dirty,
    errors,
    isValid,
  } = props;

  const handleChangeMultiple = field => event => {
    event.preventDefault();
    let value = event.target.value;
    setFieldValue(field, value);
  };

  return (
    <form>
      <Grid container direction="column" justify="center" alignItems="center">
        <TextField
          label="Nombre*"
          id="name"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={name}
          helperText={touched.name && errors.name ? errors.name : ''}
          error={touched.name && errors.name ? true : false}
          fullWidth
        />

        <TextField
          label="Apellido paterno*"
          id="firstLastName"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={firstLastName}
          helperText={
            touched.firstLastName && errors.firstLastName
              ? errors.firstLastName
              : ''
          }
          error={touched.firstLastName && errors.firstLastName ? true : false}
          fullWidth
        />

        <TextField
          label="Apellido materno*"
          id="secondLastName"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={secondLastName}
          helperText={
            touched.secondLastName && errors.secondLastName
              ? errors.secondLastName
              : ''
          }
          error={touched.secondLastName && errors.secondLastName ? true : false}
          fullWidth
        />

        

       <FormControl
          error={touched.gender && errors.gender ? true : false}
          component="fieldset"
        >
          <div className={classes.rootFormControl}>
            <FormLabel component="legend" style={{ flexGrow: 1 }}>
              Género:
            </FormLabel>
            <RadioGroup
              row
              aria-label="gender"
              name="gender"
              value={gender}
              onChange={handleChangeMultiple('gender')}
              onBlur={handleBlur}
            >
              <FormControlLabel
                value="female"
                control={<Radio color="primary" />}
                label="Mujer"
              />
              <FormControlLabel
                value="male"
                control={<Radio color="primary"/>}
                label="Hombre"
              />
            </RadioGroup>
          </div>
          {touched.gender && errors.gender ? (
            <FormHelperText
              color="error"
              classes={{ root: classes.formHelperText }}
            >
              {errors.gender}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
      </Grid>

      <div className="horizontal-layout" style={{ marginTop: 15 }}>
        <Link to="/RegistroAbogadoData">
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            disabled={!isValid}
          >
            Continuar
          </ButtonBase>
        </Link>
      </div>
    </form>
  );
};

export default SignUpForm;
